import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"600\"],\"subsets\":[\"latin\"],\"fallback\":[\"Yu Gothic\",\"Hiragino Sans\",\"Noto Sans JP\",\"Noto Sans CJK JP\",\"sans-serif\"]}],\"variableName\":\"geist\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AppInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/consent/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header.tsx");
